import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { CompanyDetailsFooter } from '@/components/CompanyDetailsFooter';
import { amplitudeModule } from '@/modules/amplitude';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { OBEDIENCE_OPTIONS } from './constants';

export const ScreenObedience: React.FC = () => {
  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const obedience = form.watch('obedience');
  const gender = form.watch('gender');

  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Obedience',
      });
    }
  }, []);

  const handleChange = (option: OnbOptionType<LayoutDataType['obedience']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        obedience: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const title =
    gender === 'male'
      ? 'Should he challenge your ideas or agree with you more often?'
      : 'Should she challenge your ideas or agree with you more often?';

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent>
        <OwnAiTitle>{title}</OwnAiTitle>
        <OnboardingOptionsList>
          {OBEDIENCE_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={obedience === option.id}
              control={form.control}
              option={option}
              name="obedience"
              key={option.id}
              onChange={() => handleChange(option)}
              TEST_ID={`obedience-${option.id}`}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      <CompanyDetailsFooter extraPadding />
    </OnboardingPage>
  );
};
